import { Customer } from "./customer";
import { Opportunity, OpportunityFile } from "./opportunity";

export enum OrderStatus {
  Kickoff = "KICKOFF",
  Developing = "DEVELOPING",
  Acceptance = "ACCEPTANCE",
  Handover = "HANDOVER",
  Collecting = "COLLECTING",
  Done = "DONE",
}

export enum OrderDebtStatus {
  Unpaid = "UNPAID",
  Paid = "PAID",
}

export enum OrderDebtFilter {
  Full = "FULL",
  None = "NONE",
  Partial = "PARTIAL",
}

export interface OrderDocument {
  id: number;
  label: string;
  files: OpportunityFile[];
}

export interface OrderDebt {
  id: number;
  content: string;
  percent: number;
  amount: number;
  status: OrderDebtStatus;
  dueDate: string;
  collectedDate: string;
}

export interface OrderDetail {
  id: number;
  description: string;
  unit: string;
  quantity: number;
  price: number;
}

export interface Order {
  id: number;
  createdAt: number;
  updatedAt: number;
  code: string;
  contractCode: string;
  status: OrderStatus;
  collectedAmount?: number;
  detailTotal?: number;
  customer: Customer | null;
  opportunity: Opportunity | null;
  orderDocuments?: OrderDocument[];
  orderDebts?: OrderDebt[];
  orderDetails?: OrderDetail[];
}

export interface OrderCounts {
  all: number;
  statuses: Record<OrderStatus, number>;
}
